import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { UserModel } from '../../authentication/models/user.model';
import { AuthenticationService } from '../../authentication/services/authentication.service';
import { ChassisFormHandler } from '../../forms/form/classes/form-handler';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Subject } from 'rxjs/Subject';
import { UserService } from './../../authentication/services/user.service';
import { BUTTONS } from '../../support/buttons';
import { ToolbarService } from '../../layouts/toolbar/services/toolbar.service';
import { FormFactory } from '../../forms/form.services';

@Component({
    selector: 'chassis-profile-page',
    templateUrl: './profile.page.html',
    styleUrls: ['./profile.page.scss']
})
export class ProfilePage implements OnInit, AfterViewInit {

    /**
     * The mode of the page that is being shown
     *
     * @type {string}
     */
    protected pageMode = 'edit';

    /**
     * The singular form of the model
     *
     * @type {string}
     */
    protected singular = 'profile';

    /**
     * The plural form of the model
     *
     * @type {string}
     */
    protected plural = 'profiles';

    /**
     * The title of the page
     *
     * @type {string}
     */
    protected title = this.singular;

    /**
     * The route prefix for the buttons
     *
     * @type {string}
     */
    protected routePrefix = this.singular;

    /**
     * The plugin slot prefix.
     *
     * @type {string}
     */
    protected pluginPrefix = 'chassis-profile';

    /**
     * The ChassisFormHandler form instance.
     */
    protected form: ChassisFormHandler;

    /**
     * The UserModel instance.
     *
     * @type {UserModel}
     */
    protected model: Subject<UserModel> = new ReplaySubject(1);

    constructor(protected injector: Injector, protected authenticationService: AuthenticationService,
                protected userService: UserService, protected toolbarService: ToolbarService,
                protected formFactory: FormFactory) {
    }

    ngOnInit() {
        this.createForm();
        this.setModel();
    }

    ngAfterViewInit() {
        this.editToolbar();
    }

    protected setModel() {
        this.authenticationService.user().subscribe((user: UserModel) => {
            const instance = this.userService.make(user.plain());
            this.model.next(instance);
            this.form.model = instance;
        });
    }

    /**
     * Create the form.
     */
    protected createForm() {
        this.form = this.formFactory.create('user', this.model);

        this.form.processor((data: Object, resolve, reject) => {
            this.model.subscribe((user: any) => {
                this.userService.put(user.id, user)
                    .subscribe((updatedUser) => {
                        resolve(updatedUser);
                    }, (error) => {
                        reject(error);
                    });
            });
        });
    }

    protected editToolbar() {
        this.toolbarService.remove(BUTTONS.DELETE.NAME);
        this.toolbarService.remove(BUTTONS.BACK.NAME);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/profile/profile.page.ts